module.exports = __webpack_public_path__ + "img/builder-36.941d0733.webp";